export default {
  apiKey: "AIzaSyAk8MS-jRXL7bqdT1IR6vO_9uKGi0UbSM0",
  authDomain: "global-rescue-2088b.firebaseapp.com",
  databaseURL: "https://global-rescue-2088b.firebaseio.com",
  projectId: "global-rescue-2088b",
  storageBucket: "global-rescue-2088b.appspot.com",
  messagingSenderId: "660890692804"
};


// WEBPACK FOOTER //
// ./src/firebaseConfig.js